import tochtApi from "../../../api/e-loket/tochtApi";
import FilesHelper from "../../common/FilesHelper";
import samenvattingApi from "../../../api/e-loket/samenvattingApi";
import * as types from "../../../constants/ComponentConstants";
import { getFilesComponentProps } from "../../common/FilesHelperUtil";
import { prependRoot } from "../../../util/prependRoot.js";
import { getApiRoot } from "../../../store/configureStore.js";
import { gpxToGeoJson } from "../../common/map/GpxService";
import { FeatureNames, ZoneStyle } from "../../common/map/MapConstants";

export default class SamenvattingPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const params = context.props.match.params;
        const modelId = params.modelId;

        this.context.filesHelper = new FilesHelper(context, modelId);

        context.setState({
            modelId
        });

        samenvattingApi.get(modelId)
            .then((response) => {
                ajaxActions.ended();
                this.processModel(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    processModel(response) {
        const context = this.context;
        let model = response.data;

        const lussen = model.lussen.filter(x => !!x.gpxContent).map((x, i) => {
            const colorIndex = i % (types.ColorArray.length + 1);
            return {
                naam: x.naam,
                geoJson: this.getGpx(x.gpxContent),
                color: types.ColorArray[colorIndex]
            };
        });

        let customBounds = [];
        if (lussen && lussen.length)
            lussen.forEach(x => {
                if (x.geoJson && x.geoJson.features && x.geoJson.features.length)
                    customBounds.push(...x.geoJson.features[0].geometry.coordinates.map((c) => typeof c[0] === 'number' ? [c[1], c[0]] : c.map(x => [x[1], x[0]])));
            });

        context.setState({
            lussen: lussen,
            tochtNaam: model.tochtNaam,
            datum: model.datum,
            customBounds: customBounds
        });
    }

    getStratenlijstFilesProps() {
        const context = this.context;
        const fileName = `Alfabetische stratenlijst_${context.state.tochtNaam}.csv`;

        const files = [{
            display: fileName,
            urlParam: context.state.modelId
        }];

        return getFilesComponentProps(
            "Alfabetische stratenlijst/gemeente",
            "stratenlijst",
            prependRoot("/samenvatting/", getApiRoot()),
            {
                stratenlijst: files
            },
            true, null, null, null, false, null, null, types.COLOR_PURPLE, 6);
    }

    getGpx(gpxContent) {
        return gpxToGeoJson(gpxContent);
    }

    setStyle(feature, color) {
		if (feature && feature.properties && feature.properties.name === FeatureNames.BEVOORRADINGSZONE)
			return ZoneStyle;

		return { color: color };
	}

    genereerPDF(pdfPollingProps) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const filesHelper = this.context.filesHelper;
        const tochtId = context.state.modelId;

        ajaxActions.started();
        tochtApi.genereerPDF(tochtId).then((response) => {
            ajaxActions.ended();
            filesHelper.startPolling(pdfPollingProps);
        });
    }
}
